/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrganisationRoleFromJSON, OrganisationRoleToJSON, } from './';
export function OrganisationCreationRequestFromJSON(json) {
    return OrganisationCreationRequestFromJSONTyped(json, false);
}
export function OrganisationCreationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'organisationRoles': !exists(json, 'organisationRoles') ? undefined : (json['organisationRoles'].map(OrganisationRoleFromJSON)),
        'active': json['active']
    };
}
export function OrganisationCreationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'organisationRoles': value.organisationRoles === undefined ? undefined : (value.organisationRoles.map(OrganisationRoleToJSON)),
        'active': value.active
    };
}
